module.exports = __webpack_public_path__ + "assets/5db408a0c1e18a22fdc55cd15a788b69.mp4";